import { AlertService } from 'src/app/services/alert/alert.service';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TotalPassService } from './../../../services/totalPass/total-pass.service';
import { RemoteConfigService } from 'src/app/services/remote-config/remote-config.service';
import { Component, OnInit } from '@angular/core';
import { LanguagesService } from 'src/app/services/languagesService/languages.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { UserService } from 'src/app/services/user/user.service';
import { StorageService } from 'src/app/services/storage/storage.service';

const EstatesCards = {
  CONVENIO_NO_EXISTE: "Convenio no existe",
  GENERADA: "Generada",
  ENTREGADA: "Entregada",
  PENDIENTE_ACTIVAR: "Pendiente Activar",
  SIN_INFORMACION: "Sin Informacion"
}

interface DataStatusCard {
  "conexiontotal": number;
  "tarjeta": string;
  "estado": number;
  "estadoGral": number;
  "descripcion": string;
}
interface ConfigProgram {
  availablePoints: number
  costoCentsTnx: number
  factor: number
  pointValueCents: number
  pointsMaxRecharge: number
  pointsMinCostTnx: number
  pointsMinRecharge: number
  amountCents: number
}
@Component({
  selector: 'app-total-pass',
  templateUrl: './total-pass.page.html',
  styleUrls: ['./total-pass.page.scss'],
})
export class TotalPassPage implements OnInit {
  EnableForm = false
  DataStatusCard: DataStatusCard;
  hasMessage = false
  message: string = ""
  StateCard: string;
  EstatesCards = EstatesCards;
  valueRecharge = ""
  InfoMinimalAmount
  InfoRechargeCard: ConfigProgram;

  cardsValidated = false;

  ActivatedForm: FormGroup;
  RechargeForm: FormGroup;

  infoConfigProgram: ConfigProgram;
  constructor(
    public languageService: LanguagesService
    , private remoteConfig: RemoteConfigService
    , private totalPassService: TotalPassService
    , private formBuilder: FormBuilder
    , private authService: AuthService
    , private userService: UserService
    , private alertService : AlertService) {
    this.ActivatedForm = this.formBuilder.group({
      numberCard: ["",
        Validators.compose([Validators.required, Validators.minLength(7), Validators.maxLength(7), Validators.max(9999999), Validators.min(999999)
        ])
      ]
    });
    this.RechargeForm = this.formBuilder.group({
      valueRecharge: ["",
        Validators.compose([Validators.required]),
      ],
      documento:['',
      Validators.compose([Validators.required ,Validators.pattern(/^[0-9]+$/)]), Validators.maxLength(12)],
      nombres:['',
      Validators.compose([Validators.required ,Validators.pattern(/^[A-Za-z ]+$/)]),],
      apellidos:['',
      Validators.compose([Validators.required ,Validators.pattern(/^[A-Za-z ]+$/)]),],
    });
  }

  ngOnInit() {
   this.getEnableForm();
   this.ObserversForms();
  }

  ionViewDidEnter(){
    this.getEnableForm();
   /// this.fillFormRecharge()
  }

  ObserversForms(){
    this.ActivatedForm.get("numberCard").valueChanges.subscribe(() => {
      this.cardsValidated = false;
      let value: number = this.ActivatedForm.get("numberCard").value
      if (value?.toString().length > 7) {
        let newValue = value.toString().slice(0, 7)
        newValue = newValue.replace(/[^0-9]/g, "")
        this.ActivatedForm.get("numberCard").setValue(newValue)
      }
      this.validateNumberCard();
    })

    this.RechargeForm.get("valueRecharge").valueChanges.subscribe(() => {
      let value = this.RechargeForm.get("valueRecharge").value
      this.valueRecharge = value
      this.totalPassService.getInfoRechargeCard(value).then((res: ConfigProgram) => {
        this.InfoRechargeCard = res
      })
    })
  }

  async getEnableForm() {
    this.remoteConfig.getEnableForm().subscribe((res) => {
      this.EnableForm = res;
      if (this.EnableForm) {
        this.verifyStatusCard()
      }

    });
  }

  verifyStatusCard() {
    this.totalPassService.verifyStatusCard().then((res: DataStatusCard) => {
      this.DataStatusCard = res;
      if (!res.estado) {
        this.hasMessage = true;
        this.message = res["descripcion"]
      } else {
        if (res.estadoGral == 6) {
          this.StateCard = this.EstatesCards.ENTREGADA
          this.getConfigProgram()
        } else if (res.estadoGral == 5) {
          this.StateCard = this.EstatesCards.PENDIENTE_ACTIVAR
        } else {
          this.hasMessage = true;
          this.message = this.getTextIUTotal.messageDefault;
        }
      }


    }).catch((err) => {
      console.error('verifyStatusCard catch((err) => ',err)
      this.hasMessage = true;
      this.message = err.error.message
      console.log(err);

    })
  }

  activateCard() {
    this.totalPassService.activateCard(this.DataStatusCard.tarjeta).then((res) => {
      if (res["conexiontotal"]) {
        this.alertService.presentAlert("activacion exitosa")
        this.getEnableForm();
      }
    }).catch((err) => {
      console.error('activateCard Error', err);

    })
  }
  
  rechargeCard() {
    const data = this.RechargeForm.value;
     this.totalPassService.rechargeCard(data).then((res) => {
      if (res["conexiontotal"]) {
        this.alertService.presentAlert("recarga Exitosa")
        this.RechargeForm.reset();
      }
    }).catch((err) => {
      console.log(err);

    }) 
  }

  validateNumberCard() {
    let valueInput: number = this.ActivatedForm.get("numberCard").value
    let valueCard = this.DataStatusCard.tarjeta.replace(/-/g, "")
    if (valueInput?.toString() == valueCard) {
      this.cardsValidated = true
    }
  }

  getConfigProgram() {
    this.totalPassService.configProgram()
      .then(async (res: ConfigProgram) => {
        this.infoConfigProgram = res
        this.RechargeForm.get("valueRecharge").setValidators([Validators.min(res.pointsMinRecharge), Validators.max(res.pointsMaxRecharge), Validators.required])
        this.InfoMinimalAmount = this.getTextIUTotal.InfoMinimalAmount.replace("@pointsMinCostTnx", res.pointsMinCostTnx.toString()).replace("@costoCentsTnx", (res.costoCentsTnx / 100).toString())
        await this.fillFormRecharge();
      }).catch((err) => {
        console.log(err);
  
      })
  }

  async fillFormRecharge() {
    try {
      const getPublicDataProfile = await this.authService.getPublicDataProfile();
      const data:any = await getPublicDataProfile.toPromise();
      if (data) {
        if (Object.keys(data).includes('personal_data')) {
          console.debug(Object.keys(data).includes('personal_data'))
          this.RechargeForm.get("nombres").setValue(data.personal_data.name)
          this.RechargeForm.get("apellidos").setValue(data.personal_data.last_name)
          this.RechargeForm.get("documento").setValue(data.personal_data.doc_number)
          this.RechargeForm.updateValueAndValidity();
        }
      }

      const userInfoData = await this.userService.getUserInfoWithoutSub();
      if (userInfoData) {
        const inputForms = { nombres:'name', apellidos:'lastnames', documento:'docNumber'}
        Object.keys(inputForms).forEach((data)=>{
          if (!this.RechargeForm.get(data).value) {
            this.RechargeForm.get(data).setValue(userInfoData[inputForms[data]])
          }
        })
        this.RechargeForm.updateValueAndValidity();
      }
    } catch (error) {
      console.error('fillFormRecharge catch err', error)
    }

  }

  get getTextIUCurrency() {
    return this.languageService.textsIU.currency_data;
  }
  get getTextIUTotal() {
    return this.languageService.textsIU.page_TotalPass; 
  }
}
